import { createFileRoute } from '@tanstack/react-router'

import { RecentsPage } from '@/pages/recents/Recents.page'

export const Route = createFileRoute('/_auth/recents')({
  beforeLoad: () => {
    // TODO: we should check if the user has access to the projects
  },
  component: RecentsPage,
  loader: () => ({ breadcrumbTitle: 'Recents' }),
})
